const CarValuesEstimatorArray = [
    {carSizeNbr: 100, pctTradeInArr: [0.82, 0.71, 0.62, 0.54, 0.47,
            0.41, 0.36, 0.32, 0.28, 0.25, 0.22, 0.19, 0.17, 0.15,
            0.13, 0.12, 0.10, 0.09, 0.08, 0.07]}, // Small/economy
    {carSizeNbr: 200, pctTradeInArr: [0.83, 0.73, 0.64, 0.57, 0.50,
            0.44, 0.39, 0.35, 0.31, 0.27, 0.24, 0.21, 0.19, 0.17,
            0.15, 0.13, 0.12, 0.10, 0.09, 0.08]}, // Mid-size
    {carSizeNbr: 300, pctTradeInArr: [0.85, 0.76, 0.68, 0.61, 0.55,
            0.49, 0.44, 0.40, 0.36, 0.32, 0.29, 0.26, 0.23, 0.21,
            0.19, 0.17, 0.15, 0.13, 0.12, 0.10]}, // SUV
    {carSizeNbr: 400, pctTradeInArr: [0.78, 0.66, 0.56, 0.48, 0.41,
            0.35, 0.30, 0.26, 0.22, 0.19, 0.16, 0.14, 0.12, 0.10,
            0.09, 0.08, 0.07, 0.06, 0.055, 0.05]}, // Sports cars
    {carSizeNbr: 500, pctTradeInArr: [0.87, 0.79, 0.72, 0.66, 0.60,
            0.55, 0.50, 0.46, 0.42, 0.38, 0.35, 0.32, 0.29, 0.26,
            0.24, 0.21, 0.19, 0.17, 0.15, 0.13]}  // Trucks
];
export default CarValuesEstimatorArray   